import { render, staticRenderFns } from "./ImgContentYjj.vue?vue&type=template&id=4a71be3a&scoped=true&"
import script from "./ImgContentYjj.vue?vue&type=script&lang=js&"
export * from "./ImgContentYjj.vue?vue&type=script&lang=js&"
import style0 from "./ImgContentYjj.vue?vue&type=style&index=0&id=4a71be3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71be3a",
  null
  
)

export default component.exports